export const overrides = theme => ({})

export const props = {
  indicatorColor: 'primary',
  textColor: 'primary',
  scrollButtons: 'off',
}
